import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements AfterViewInit {
    @Input() title = '';
    @ViewChild('endButtons') endButtons: ElementRef;
    @ViewChild('startButtons') startButtons: ElementRef;

    ngAfterViewInit(): void {
        // Calculate the width of buttons to center the collapsed title
        const interval = setInterval(() => {
            const maxWidth = Math.max(this.startButtons.nativeElement.clientWidth, this.endButtons.nativeElement.clientWidth);

            if (maxWidth !== 0) {
                this.startButtons.nativeElement.style.width = maxWidth + 'px';
                this.endButtons.nativeElement.style.width = maxWidth + 'px';
                clearInterval(interval);
            }
        }, 10);
    }
}
